import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { Layout } from "./components/layout/Layout";
import { Login } from "./pages/Login";
import { SSOCallback } from "./pages/SSOCallback";
import { Dashboard } from "./pages/Dashboard";
import { Users } from "./pages/Users";
import { Subscriptions } from "./pages/Subscriptions";
import { Costs } from "./pages/Costs";
import { Statistics } from "./pages/Statistics";
import { Products } from "./pages/Products";
import { Entries } from "./pages/Entries";
import { Refacturation } from "./pages/Refacturation";
import { Development } from "./pages/Development";
import { useEffect } from "react";

function App() {
  // Suppress ResizeObserver errors globally
  useEffect(() => {
    const handleError = (event) => {
      if (event.message && event.message.includes('ResizeObserver')) {
        event.preventDefault();
        event.stopPropagation();
        return true;
      }
    };
    
    window.addEventListener('error', handleError, true);
    return () => window.removeEventListener('error', handleError, true);
  }, []);

  return (
    <ThemeProvider>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/sso" element={<SSOCallback />} />
              <Route path="/" element={<Layout />}>
                <Route index element={<Dashboard />} />
                <Route path="users" element={<Users />} />
                <Route path="products" element={<Products />} />
                <Route path="entries" element={<Entries />} />
                <Route path="subscriptions" element={<Subscriptions />} />
                <Route path="costs" element={<Costs />} />
                <Route path="refacturation" element={<Refacturation />} />
                <Route path="statistics" element={<Statistics />} />
                <Route path="development" element={<Development />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster 
            position="top-right" 
            toastOptions={{
              className: 'toast-theme'
            }}
          />
        </div>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
